<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="transaction_not_found">
      <span>Transaction record with id: {{ $route.params.id }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'associate-transactions'}" class="text-inherit underline">All Transactions</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="transaction_data">
      <vx-card title="Transaction Details" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Order Id</td>
                <td>{{ transaction_data.order_id }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Amount</td>
                <td>{{ transaction_data.amount_label }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Order Date</td>
                <td>{{ transaction_data.order_date}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Payment Method</td>
                <td>{{ transaction_data.payment_method }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Payment Status</td>
                <td>{{ transaction_data.paid_status}}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Event Name</td>
                <td><router-link :to="`/associate/event/view/${transaction_data.event_id}`" class="text-inherit underline hover:text-primary">{{ transaction_data.event_name }}</router-link></td>
              </tr>
              <tr>
              <tr>
                <td class="font-semibold">Category Name</td>
                <td><router-link :to="`/associate/service-request/view/${transaction_data.service_request_id}?tab=transaction`" class="text-inherit underline hover:text-primary">{{ transaction_data.category_name }}</router-link></td>
              </tr>
              <tr>
                <td class="font-semibold">User Name</td>
                <td><router-link :to="`/associate/users/${transaction_data.role.role}/view/${transaction_data.user_id}?tab=transaction`" class="text-inherit underline hover:text-primary">{{ transaction_data.user_name }}</router-link></td>
              </tr>
              <tr>
                <td class="font-semibold">User Email</td>
                <td>{{ transaction_data.email }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <!--<vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              :to="{name: 'service-request-edit', params: { id: $route.params.id }}"
            >Edit</vs-button>-->
            <!--<vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="confirmDeleteRecord"
            >Delete</vs-button>-->
          </div>
        </div>
      </vx-card>

      <vx-card v-if="transaction_data.transaction">
        <vs-tabs>
          <vs-tab label="Transaction Details" icon-pack="feather" icon="icon-package">
            <div>
              <pre> {{ transaction_data.transaction }}</pre>
            </div>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleSupport from '@/store/support/moduleSupport.js'

export default {
  data () {
    return {
      transaction_data: null,
      transaction_not_found: false
    }
  },
  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.transaction_data.order_id}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      /*this.$router.push({ name: "app-user-list" })
      this.showDeleteSuccess()*/

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store.dispatch('support/deleteTransaction', this.transaction_data.id)
        .then(()   => { this.$router.push({name:'transactions'}); this.showDeleteSuccess() })
        .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Transaction Deleted',
        text: 'The transaction was successfully deleted'
      })
    }
  },
  created () {
    this.$emit('changeRouteTitle', 'Transaction')
    // Register Module UserManagement Module
    if (!moduleSupport.isRegistered) {
      this.$store.registerModule('support', moduleSupport)
      moduleSupport.isRegistered = true
    }

    const id = this.$route.params.id
    this.$store
      .dispatch('support/fetchTransaction', id)
      .then((res) => {
        this.transaction_data = res.data.data
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.transaction_not_found = true
          return
        }
        console.error(err)
      })
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
